export const PAYMENT_REQUIREMENTS_MODULE_NAME: string = 'paymentRequirements';